import CrudCustom from '../../../libs/custom/CrudCustom';

let PengaturanBiayaSptService = new CrudCustom('/tipe-biaya-lamp-1771-iis');
export default PengaturanBiayaSptService;
